/**
 * @author PoornaChandu
 * @description updated code
 */
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { StyledComponent, StyledModal, StyledForm } from './CSS/style';
import Highlighter from 'react-highlight-words';
import { getList } from './Utils/FormCalls';
import { API_BACKUP } from '../../../commons/api';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Input,
  Form,
  Tooltip
} from 'antd';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';

import StyledTable from '../../../commons/styles/table';
import dayjs from 'dayjs';

const APIList = {
  getList: `${API_BACKUP.TasksGet}`
};

const TaskScheduler = (props) => {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([]);
  const [viewMore, setViewMore] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  // const [formObject, setFormObject] = useState({});
  const [userProfile,setUserProfile] = useState(props.userProfile);
  const [translationCache,setTranslationCache] = useState(props.translationCache);
  const RealTimeModelRef = useRef(null);
  const searchInput = useRef(null);
  useEffect(() => {
    const fetchData = async () => {
      const response = await getList(APIList.getList);
      setDataSource(response && Array.isArray(response) ? response : []);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (
      props.userProfile !== userProfile ||
      props.translationCache !== translationCache
    ) {
      setTranslationCache(props.translationCache);
      setUserProfile(props.userProfile);
    }  }, [userProfile, translationCache]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          
          style={{
            width: 90,
            marginRight: '5px'
          }}
        >
          Search
        </Button>
        <Button
          onClick={() => clearFilters && handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText('');
  };

  const handleAddTask = () => {
    navigate('/rubus/TaskSchedulerDetails');
  };

  const editRecord = (record) => {
    navigate(
      `/rubus/TaskSchedulerDetails/${record.Id}`
    );
  };

  const columns = [
    {
      title: translation('Task Name'),
      dataIndex: 'TaskName',
      key: 'TaskName',
      ...getColumnSearchProps('TaskName')
    },
    {
      title: translation('Scheduled Time'),
      dataIndex: 'ScheduledTime',
      key: 'ScheduledTime',
      ...getColumnSearchProps('ScheduledTime'),
      sorter: (a, b) => new Date(a.ScheduledTime) - new Date(b.ScheduledTime),
      render: (text) => (
        text !== undefined && text !== null ? (
          <div>{dayjs(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      )
    },
    {
      title: translation('Start Time'),
      key: 'StartDate',
      dataIndex: 'StartDate',
      ...getColumnSearchProps('StartDate'),
      sorter: (a, b) => new Date(a.StartDate) - new Date(b.StartDate),
      render: (text) => (
        text !== undefined && text !== null ? (
          <div>{dayjs(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      )
    },
    {
      title: translation('End Time'),
      key: 'EndDate',
      dataIndex: 'EndDate',
      ...getColumnSearchProps('EndDate'),
      sorter: (a, b) => new Date(a.EndDate) - new Date(b.EndDate),
      render: (text) => (
        text !== undefined && text !== null ? (
          <div>{dayjs(text).utc().local().format('YYYY-MM-DD HH:mm:ss')}</div>
        ) : null
      )
    },
    {
      title: translation('Status'),
      dataIndex: 'TaskStatus',
      key: 'TaskStatus',
      ...getColumnSearchProps('TaskStatus')
    },
    {
      title: translation('Action'),
      width: '600',
      render: (text, record) => (
        <Tooltip title={translation('Edit')}>
          <Button
            style={{ marginRight: '5px' }}
            className="ant-btn"
            onClick={() => editRecord(record)}
            
          >
            <EditOutlined />
          </Button>
        </Tooltip>
      )
    }
  
  ];
 
  const formItemLayout = { width: '400px', flex: '50%' };

  return (
    <>
      <StyledComponent
        theme={themeSettings}
        style={{
          minHeight: window.innerHeight - 143,
          margin: '5px'
        }}
      >
        <>
          <div style={{ color: 'white', margin: '20px 20px'}}>
            {translation('Task Scheduler')}
          </div>
          <div style={{ float: 'right', marginBottom: '20px' }}>
            <Tooltip title={translation('Add Task')}>
              <Button
                type="primary"
                onClick={handleAddTask}
              >
                {translation('Add Task')}
              </Button>
            </Tooltip>
          </div>
           {/* <div style={{ float: 'right' }}>
              <Tooltip title={this.translation('History')}>
                <Button
                  type="primary"
                  //   icon={<PlusOutlined />}
                  //   onClick={() => this.adQuestionForm()}
                >
                  {this.translation('History')}
                </Button>
              </Tooltip>
            </div> */}
          <div style={{ marginTop: '40px' }}>
            <StyledTable size="small"
              dataSource={dataSource && Array.isArray(dataSource) ? dataSource : []}
              columns={columns}
            />
          </div>
          <StyledModal
            width="1500px"
            open={viewMore}
            onCancel={() => setViewMore(false)}
            closable
            theme={themeSettings}
            footer={[
              <>
                <Button
                  key="back"
                  onClick={() => setViewMore(false)}
                >
                  {translation('Cancel')}
                </Button>
                <Button key="Submit" type="primary" >
                  {translation('Submit')}
                </Button>
              </>
            ]}
          >
            <StyledForm
              className="TaskScheduler"
              name="TaskScheduler"
              ref={RealTimeModelRef}
              autoComplete="off"
              theme={themeSettings}
              layout="horizontal"
              labelCol={{ flex: '200px' }}
              labelAlign="right"
              // onFinish={onRealTimeModelSubmit}
              // onFinishFailed={this.onFinishFailed}
              labelWrap
              wrapperCol={{ flex: 1 }}
            >
              <div style={{ display: 'flex', flexWrap: 'wrap', width: '1300px' }}>
                <Form.Item
                  name="DataStorageLocation"
                  label={translation('Data Storage Location')}
                  style={formItemLayout}
                >
                  <Input disabled={true} style={{ width: '70%' }} />
                </Form.Item>
                <Form.Item
                  name="BackupMD5Hash"
                  label={translation('Backup MD5 Hash')}
                  style={formItemLayout}
                >
                  <Input style={{ width: '70%' }} />
                </Form.Item>
                <Form.Item
                  label={translation('Estimated total size')}
                  name="EstimatedTotalSize"
                  style={formItemLayout}
                >
                  <Input style={{ width: '70%' }} />
                </Form.Item>
                <Form.Item
                  label={translation('Activity start')}
                  name="ActivityStart"
                  style={formItemLayout}
                >
                  <Input style={{ width: '70%' }} />
                </Form.Item>
                <Form.Item
                  label={translation('Activity end')}
                  name="ActivityEnd"
                  style={formItemLayout}
                >
                  <Input style={{ width: '70%' }} />
                </Form.Item>
                <Form.Item
                  label={translation('Status')}
                  name="Status"
                  style={formItemLayout}
                >
                  <Input style={{ width: '70%' }} />
                </Form.Item>
              </div>
            </StyledForm>
          </StyledModal>
        </>
      </StyledComponent>
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile
});

export default connect(mapStateToProps)(TaskScheduler);